import { Alert, AlertTitle } from '@mui/material';
import {
  BenefitActivationDTO,
  BenefitDTOBenefitEnum,
  BenefitTemplateItemDTO,
  CreateBenefitActivationDTO,
  UpdateBenefitActivationDTO,
} from 'probonio-shared-ui/api';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { BenefitActivationDialogExtensionInterface } from '../../../../extension/interface/benefit-activation-dialog.extension.interface';
import { ActivationDialogExtensions } from '../../ActivationDialog';
import { isCarPreconditionMet, useCarPrecondition } from '../useCarPrecondition';

interface CarBenefitOptions {}

const Fields: React.FC = () => {
  const { setError, clearErrors } = useFormContext();
  const { isPreconditionMet } = useCarPrecondition();
  const { t } = useTranslation('benefitsModule');

  useEffect(() => {
    if (!isPreconditionMet) {
      setError('root', {
        message: 'error',
      });
    } else {
      clearErrors('root');
    }
  }, [clearErrors, isPreconditionMet, setError]);

  return isPreconditionMet ? (
    <Alert severity="info">
      <AlertTitle>{t('CAR.activate.alert.infoTitle')}</AlertTitle>
      <Trans
        i18nKey="benefitsModule:CAR.activate.alert.infoDescription"
        components={{
          settings: <Link to="/benefits/car/settings" />,
        }}
      />
    </Alert>
  ) : (
    <Alert severity="warning">
      <AlertTitle>{t('CAR.activate.alert.title')}</AlertTitle>
      <Trans
        i18nKey="benefitsModule:CAR.activate.alert.description"
        components={{
          settings: <Link to="/benefits/car/settings" />,
        }}
      />
    </Alert>
  );
};

const createCarBenefitActivation: ActivationDialogExtensions<CarBenefitOptions>['onCreateActivation'] = async (
  baseValues,
  benefitOptions,
  saveActivation,
) => {
  const create: CreateBenefitActivationDTO = {
    ...baseValues,
    benefit: BenefitDTOBenefitEnum.Car,
  };
  await saveActivation(create);
};

const updateCarBenefitActivation: ActivationDialogExtensions<CarBenefitOptions>['onUpdateActivation'] = async (
  baseValues,
  benefitOptions,
  saveActivation,
) => {
  const update: UpdateBenefitActivationDTO = {
    ...baseValues,
  };
  await saveActivation(update);
};

const resetCarBenefitOptions = (selectedActivation?: BenefitActivationDTO | BenefitTemplateItemDTO): CarBenefitOptions => {
  return {};
};

export class CarBenefitActivationDialogExtension extends BenefitActivationDialogExtensionInterface<CarBenefitOptions> {
  CreateFields?: React.ReactNode = (<Fields />);
  ChangeOptionsFields?: React.ReactNode = (<Fields />);

  onCreateActivation = createCarBenefitActivation;
  onUpdateActivation = updateCarBenefitActivation;
  onResetBenefitOptions = resetCarBenefitOptions;
  isPreconditionMet = isCarPreconditionMet;
}
